import Vue from 'vue';

const setComponentName = (el: HTMLElement, file: string) => {
  try {
    const matchArr = (file || '').match(/\/?(\w+).vue/);
    const name = matchArr ? matchArr[1] : '';

    if (el.className && el.className.includes('v-portal')) {
      return;
    }

    if (el && name && el.setAttribute) {
      el.setAttribute(`data-test-root-${name}`, '');
    }
    // eslint-disable-next-line
  } catch (e) {
    // console.log('err', el);
  }
};

const Cypress = {
  installed: false,

  // @ts-ignore
  install(vue) {
    if (this.installed) return;
    this.installed = true;

    // PLEASE KEEP IT FOR TEST PURPOSES. ONLY FOR DEVELOPMENT
    // if (process.env.isDev && process.client) {
    //   // @ts-ignore
    //   // eslint-disable-next-line
    //   window.root = require('../../qa/cypress/components/generated/index');
    // }

    vue.mixin({
      mounted() {
        setComponentName(this.$el, this.$options.__file);
      },
      updated() {
        setComponentName(this.$el, this.$options.__file);
      },
    });
  },
};

Vue.use(Cypress);
